function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('application',['module/Menu', 'module/Overlays', 'module/StartCaseStudy', 'module/MultipleChoice', 'module/RangeSlider', 'module/Expandable', 'module/Video-Manager', 'module/OnlineTraining'], function (Menu, Overlays, StartCaseStudy, MultipleChoice, RangeSlider, Expandable, CortexVideoManager, OnlineTraining) {
  'use strict';

  var Application = /*#__PURE__*/_createClass(function Application() {
    var _this = this;
    _classCallCheck(this, Application);
    /**
     * Init all modules.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-03-16
     * 
     */
    _defineProperty(this, "init", function () {
      var oMenu = new Menu();
      var oOverlays = new Overlays();
      var oMultipleChoice = new MultipleChoice();
      var oStartCaseStudy = new StartCaseStudy();
      var oRangeSlider = new RangeSlider();
      var oExpandable = new Expandable();
      var oCortexVideoManager = new CortexVideoManager();
      var oOnlineTraining = new OnlineTraining(_this.log);
      window.onlineTraining = oOnlineTraining;
    });
    /**
     * Log given string if in debug mode.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-03-16
     * 
     * @param {string} s 
     */
    _defineProperty(this, "log", function (s) {
      if (true === _this.bDebug) {
        console.log(s);
      }
    });
    this.bDebug = true;
    this.init();
  });
  return {
    Application: Application
  };
});

